import Vue from 'vue'
import Vuex from 'vuex'
import MetricsService from '../../services/MetricsService'
import VueMoment from 'vue-moment'

Vue.use(Vuex)
Vue.use(VueMoment)
export default {
  namespaced: true,
  state: {
    filters: {
      startMonth: '2015-01-01',
      endMonth: Vue.moment().startOf('month').format('YYYY-MM-DD')
    },
    data: {
      summary: []
    }
  },
  mutations: {
    setData (state, data) {
      state.data = data
    }
  },
  actions: {
    loadData ({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true, {root: true})
        let metricsService = new MetricsService()
        metricsService
        .getSummary({
            'currency': 'nzd',
            'frequency': 'monthly',
            'start_at': state.filters.startMonth,
            'end_at': state.filters.endMonth,
            'metrics': [
                'one_off_purchase_count_for_past_90_days',
                'active_member_count'
            ]
        })
        .then((res) => {
            commit('setData', res.data)
            resolve()
        })
        .catch((e) => {
            reject(e)
        })
        .finally(() => {
            commit('setLoading', false, {root: true})
        })
    })
    }
  },
  getters: {
    getPayingMembers (state) {
      const temp = {};
      for (const [metric, dates] of Object.entries(state.data.summary)) {
        for (const [date, value] of Object.entries(dates)) {
          const month = date.slice(0, 7);
          if (!temp[month]) {
            temp[month] = { month };
          }
          temp[month][metric] = parseFloat(value);
        }
      }
      const result = Object.values(temp).sort((a, b) => b.month.localeCompare(a.month));
      return result;
    }
  }
}
